<template>
    <body>
    <h1>Simple support / Maintenance page</h1>
    <br><br>
    <h2>Redeem Management <button @click="addRedeem">Add</button> </h2>
    <table id="rtable">
      <tbody>
      <tr>
        <th width="5%">Id</th>
        <th width="10%">Code</th>
        <th width="10%">NumberOfMonths</th>
        <th width="10%">Action</th>
      </tr>
      <tr v-for="(redeem,index) in this.redeemList " :key="redeem.index">
        <td>{{redeem.id}}</td>
        <td>{{redeem.code}}</td>
        <td>{{redeem.nm}}</td>
        <td><i class="fa fa-trash" aria-hidden="true" @click="deleteRedeem(redeem.id,index)"></i></td>
      </tr>
      </tbody>
    </table>
    <br>
    <h2>Business Customers Management</h2>
    <table id="btable" v-if="count_b > 0">
      <tbody>
      <tr>
        <th width="5%">Id</th>
        <th width="15%">Name</th>
        <th width="15%">Location</th>
        <th width="15%">Payed months</th>
        <th width="15%">Update payment</th>
        <th width="15%">Code</th>
        <th width="10%">Delete</th>
        <th width="10%">Show Appointments</th>
      </tr>
      <tr v-for="(myb,index) in this.blist " :key="myb.index">
        <td>{{myb.id}}</td>
        <td>{{myb.name}}</td>
        <td>{{myb.location}}</td>
        <td>{{myb.nm}}</td>
        <td><i class="fa fa-calendar" aria-hidden="true" @click="updatePayment(myb.nm,myb.id)"></i></td>
        <td><i class="fa fa-id-badge" aria-hidden="true" @click="showCode(myb.code)"></i></td>
        <td><i class="fa fa-trash" aria-hidden="true" @click="deleteBusiness(myb.id,index)"></i></td>
        <td><i class="fa fa-database" aria-hidden="true" @click="showAppointments()"></i></td>
      </tr>
      </tbody>
    </table>
    <div v-else> No business data</div>
    <h2>Pets forms</h2>
    <table id="ftable">
      <tbody>
      <tr>
        <th width="5%">No</th>
        <th width="10%">Id</th>
        <th width="10%">OfficeId</th>
        <th width="75%">Info</th>
      </tr>
      <tr v-for="(petform,index) in this.petforms " :key="petform.index">
        <td>{{index}}</td>
        <td>{{petform.id}}</td>
        <td>{{petform.officeid}}</td>
        <td>{{petform.info}}</td>
      </tr>
      </tbody>
    </table>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_post} from '../https_requests.js'
    export default {
        name: 'Support',
        data() {
            return {
                baseURL:null,
                blist: [],
                alist: [],
                redeemList: [],
                petforms:[],
                serverRsp:null,
                error_message:null,
            }
        },
        computed: {
            count_b() {
                return !this.blist ? 0 : this.blist.length
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            this.getListOfBusiness()
            this.getListOfRedeem()
            this.getPetForms()
        },
        methods: {
            updatePayment(old_months,id){
                let number_of_months = prompt('How many months ?',old_months)
                //update payment period
                if(number_of_months > old_months) {
                    fetch(this.baseURL + '/business/' + id, {
                        method: 'PUT',
                        mode: 'cors',
                        cache: 'no-cache',
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type':'application/json'
                        },
                        body: JSON.stringify({subscription_months:number_of_months})
                    }).then( rsp =>{
                        return rsp.json()
                    }).then( () => {
                        console.log('update done!')
                    }).catch(err => {
                        //console.log('Error when delete redeem ...'+err.message)
                        this.error_message = err.message
                    })
                }
            },
            showAppointments() {
                console.log('check ')
                fetch(this.baseURL+'/appointments',{
                    methods: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(rsp => {
                    return rsp.json()
                }).then( data => {
                    if(data.length > 0) {
                        this.alist=[] // init always
                        //console.log('get appointments list ',data)
                        for(let appoint of data) {
                            let aobj = {
                                comment: appoint.comment,
                                day:appoint.day,
                                month:appoint.month,
                                slot:appoint.slot,
                            }
                            this.alist.push(aobj)
                        }
                        console.log(this.alist)
                    }
                })
            },
            deleteRedeem(id,index){
                let y = confirm(`This action will delete the next Redeem: ${id}\nAre You sure ?`)
                if(y) {
                    fetch(this.baseURL + '/redeems/' + id, {
                        method: 'DELETE'
                    }).then( rsp =>{
                        return rsp.json()
                    }).then( () => {
                        // update frontend sites data
                        this.redeemList.splice(index,1)
                    }).catch(err => {
                        //console.log('Error when delete redeem ...'+err.message)
                        this.error_message = err.message
                    })
                }
            },
            deleteBusiness(id,index){
                let y = confirm(`This action will delete the next Business: ${id}\nAre You sure ?`)
                if(y) {
                    fetch(this.baseURL + '/business/' + id, {
                        method: 'DELETE'
                    }).then( rsp =>{
                        return rsp.json()
                    }).then( () => {
                        // update frontend sites data
                        this.blist.splice(index,1)
                    }).catch(err => {
                        //console.log('Error when delete business ...'+err.message)
                        this.error_message = err.message
                    })
                }
            },
            addRedeem() {
                let redeemcode = prompt('Define redeem string & free months (e.g 234568#5)')
                if(!redeemcode) {
                    //  nothing to do
                }else {
                    //console.log(redeemcode)
                    const code_months = redeemcode.split('#')
                    ulip_post(this.baseURL,'/redeems',{code: code_months[0],nmonths: code_months[1]}).then(rsp => {
                        //console.log(rsp)
                        this.serverRsp = rsp
                    }).catch(err => {
                        alert(err.message+'\nBackend could be down ...')
                    })
                }
            },
            showCode(code) {
                alert('Business private Access Key\n' + code)
            },
            getListOfRedeem() {
                fetch(this.baseURL+'/redeems',{
                    methods: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(rsp => {
                    return rsp.json()
                }).then( data => {
                    if(data.length > 0) {
                        //console.log('get redeem list ',data)
                        for(let redeem of data) {
                            let bobj = {
                                id:redeem.id,
                                code: redeem.code,
                                nm:redeem.nmonths,
                            }
                            this.redeemList.push(bobj)
                        }
                    }
                })
            },
            getListOfBusiness() {
                const tk = '69bd7de4f45da9d7a12bde4102cf25db97db6d0df6b98f130b64cfe9a6a2b12d'
               fetch(this.baseURL+'/business?token='+tk,{
                   methods: 'GET',
                   headers: {
                       'Content-Type': 'application/json'
                   },
               }).then(rsp => {
                   return rsp.json()
               }).then( data => {
                   if(data.length > 0) {
                       //console.log('get business list ',data)
                       for(let business of data) {
                           let bobj = {
                               name: business.name,
                               id: business.id,
                               code: business.code,
                               location: business.location,
                               nm:business.subscription_months,
                           }
                           this.blist.push(bobj)
                       }
                   }
               })
            },
            getPetForms() {
                fetch(this.baseURL+'/pets',{
                    methods: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(rsp => {
                    return rsp.json()
                }).then( data => {
                    if(data.length > 0) {
                        this.petforms = [] // init always
                        //console.log('get pet forms ',data)
                        for(let pf of data) {
                            let petform = {
                                id:pf.id,
                                officeid: pf.officeid,
                                info:pf.info,
                            }
                            this.petforms.push(petform)
                        }
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    body {
        height: 300vh;
    }
    #btable {
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #ddd;
        font-size: 15px;
    }
    #btable th, #bmTable td {
        text-align: center;
        //background-color: darkslategrey;
        padding: 12px;
    }

    #btable tr {
        border-bottom: 1px solid #ddd;
        //opacity: 0.7;
    }
    #btable tr.header {
        background-color: dimgray;
    }

    #btable tr:hover {
        background-color: darkslategrey;
        color:white;
    }
    #rtable {
        @extend #btable
    }
    #ftable {
        @extend #btable
    }
</style>